export default "__VITE_ASSET__DKiSXJdn__"